import React from 'react';
import { Menu, MenuItem, ListItemText, IconButton } from '@material-ui/core';
import { Delete } from '@material-ui/icons';

const Notif = ({
  anchorEl,
  open,
  handleClose,
  notifications,
  handleDeleteNotification,
  clearAllNotifications,
  markNotificationAsRead
}) => {
  const handleItemClick = notif => {
    markNotificationAsRead(notif.notifKey);
    if (notif?.data?.path) {
      window.open(`${window.location.origin}/${notif.data.path}`, '_blank');
    }
    handleClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{ style: { minWidth: '300px' } }}
    >
      {notifications.length > 0 ? (
        <>
          <MenuItem
            onClick={clearAllNotifications}
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <ListItemText primary={<>Delete All Notifications</>} />
          </MenuItem>
          {(Array.isArray(notifications) ? notifications.slice(0, 5) : []).map(
            (notif, index) => (
              <MenuItem
                key={index}
                onClick={() => handleItemClick(notif)}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  opacity: notif.read ? 0.5 : 1
                }}
              >
                <ListItemText
                  primary={
                    <>
                      {notif.data.message}{' '}
                      <span
                        style={{
                          color: 'inherit',
                          textDecoration: 'underline'
                        }}
                      >
                        {notif.data.linkText}
                      </span>
                    </>
                  }
                />
                <IconButton
                  onClick={e => {
                    e.stopPropagation(); // Prevent opening the link
                    handleDeleteNotification(notif.notifKey);
                  }}
                  size="small"
                >
                  <Delete fontSize="small" />
                </IconButton>
              </MenuItem>
            )
          )}
        </>
      ) : (
        <MenuItem disabled>
          <ListItemText primary="No new notifications" />
        </MenuItem>
      )}
    </Menu>
  );
};

export default Notif;
